module.exports = __webpack_public_path__ + "static/media/baseline-add_circle-24px.121fb69a.svg";